// @ts-nocheck
import { Button, Div, P } from '@kizi/core-components';
import React from 'react';

const splitPriceOnComma = (price) => {
  const priceString = String(price).replace('.', ',');
  const [wholePart, decimalPart] = priceString.split(',');
  return {
    wholePart,
    decimalPart: decimalPart ? `,${decimalPart}` : ',00',
  };
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--8pt-Grid-24px, 24px)',
  },
  priceCardsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--8pt-Grid-24px, 24px)',
    alignSelf: 'stretch',
  },
  priceCard: {
    display: 'flex',
    padding: 'var(--8pt-Grid-16px, 16px) var(--8pt-Grid-32px, 32px)',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 0 0',
    borderRadius: 'var(--8pt-Grid-16px, 16px)',
    background: 'var(--Grey-100, #f8f8f7)',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
  },
  priceDisplay: {
    display: 'flex',
  },
};

// Reusable Price Display Component
const PriceDisplay = ({
  price,
  label,
  color,
  wholeFontSize = '32px',
  decimalFontSize = '16px',
  decimalMarginTop = '8px',
  labelSize = '11px',
}) => {
  const editedPrice = splitPriceOnComma(price);

  return (
    <Div css={styles.priceCard}>
      <P
        variant="footnoteImportant"
        color={color}
        css={{ fontSize: labelSize }}
      >
        {label}
      </P>
      <Div css={styles.priceDisplay}>
        <P
          variant="footnoteImportant"
          color={color}
          css={{ fontSize: wholeFontSize }}
        >
          {editedPrice.wholePart}
        </P>
        <P
          variant="footnoteImportant"
          color={color}
          css={{
            mt: decimalMarginTop,
            fontSize: decimalFontSize,
          }}
        >
          {editedPrice.decimalPart}
        </P>
      </Div>
      <P variant="footnoteLight" color={color} css={{ fontSize: labelSize }}>
        per maand
      </P>
    </Div>
  );
};

export const NewPremium = ({ currentPrice, newPrice, onClick, onClose }) => {
  return (
    <Div css={styles.container}>
      <P variant="footnoteRegular">
        Je hebt een ingangsdatum ingevuld die in de toekomst ligt. Op basis van
        deze nieuwe ingangsdatum is de premie opnieuw berekend.
      </P>

      <Div css={styles.priceCardsContainer}>
        <PriceDisplay
          price={currentPrice}
          label="Oude premie"
          color="second.0"
          wholeFontSize="32px"
          decimalMarginTop="8px"
        />

        <PriceDisplay
          price={newPrice}
          label="Nieuwe premie"
          color="main.2"
          wholeFontSize="48px"
          decimalMarginTop="10px"
        />
      </Div>
      <Div
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--8pt-Grid-16px, 16px)',
        }}
      >
        <Button variant="primary" onClick={onClick} width={'100% !important'}>
          Premie accepteren en aanvragen
        </Button>
        <Button variant="transparent" onClick={onClose}>
          Of een ander product kiezen
        </Button>
      </Div>
    </Div>
  );
};

export default NewPremium;
